import { Injectable } from '@angular/core';
import { CountryLangExtendHelper } from './country-lang-extend-helper';
@Injectable({
  providedIn: 'root'
})
export class CountryLanguageHelper extends CountryLangExtendHelper {
  isDomainCorrectForPrefCookie(): boolean {
    try {
      const appDomain = this.urlUtil.baseUrl;
      const domain = this.getDomainName(appDomain);
      const languageCode = this.getLanguageCodeFromPrefCookie() || '';
      if (this.isDomainMatchesLanguage(domain, languageCode)) {
        return true;
      } else {
        const valid = this.getValidDomainName(appDomain);
        const validDomains = [
          'dvl',
          'publish',
          'author',
          'preview',
          'localhost'
        ];
        return this.isValid(domain, valid, languageCode, validDomains);
      }
    } catch (err) {
      return true;
    }
  }

  isValid(
    domain: string,
    valid: string | undefined,
    languageCode: string | null,
    validDomains: string[]
  ): boolean {
    if (valid) {
      if (
        validDomains.some(
          (validDomain) => valid === validDomain || domain.includes(validDomain)
        )
      ) {
        return true;
      }
      if (valid !== '') {
        const url = domain.split('-');
        return this.isLanguageCode(url, languageCode);
      }
    }
    return false;
  }

  isDomainMatchesLanguage(domain: string, languageCode: string): boolean {
    const exactMatches = ['www', 'si', 'st'];
    const partialMatches = [
      'qat',
      'dev1',
      'stg',
      'publish',
      'author',
      'preview',
      'st1',
      'st2',
      'st3',
      'prd'
    ];

    const isValidDomain =
      exactMatches.includes(domain) ||
      partialMatches.some((d) => domain.includes(d));

    return (isValidDomain && languageCode === 'en') || domain === languageCode;
  }

  isLanguageCode(url: string[], languageCode: string | null): boolean {
    if (url.length > 1) {
      if (url[1] === languageCode) {
        return true;
      }
    }
    return false;
  }

  isDomainCorrectForLanguageCode(languageCode: string): boolean {
    try {
      const appDomain = this.urlUtil.baseUrl;
      const domain = this.getDomainName(appDomain);
      if (this.isDomainMatchesLanguage(domain, languageCode)) {
        return true;
      } else {
        const valid = this.getValidDomainName(appDomain);
        const validDomains = ['dvl', 'localhost'];
        return this.isValid(domain, valid, languageCode, validDomains);
      }
    } catch (err) {
      return true;
    }
  }

  detectBrowserLanguage(): string | null {
    const lan = window.navigator.languages;
    if (lan && lan.length > 0) {
      const res = lan[0].split('-');
      return res[0];
    } else {
      return this.checkLang();
    }
  }

  checkLang(): string | null {
    const lang2 = window.navigator.language;
    if (lang2) {
      const res = lang2.split('-');
      return res[0];
    }
    return null;
  }
}
